/**
 * Set the components of a quat to the given values
 *
 * @param {quat} out the receiving quaternion
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} out
 * @function
 */
module.exports = require('gl-vec4/set')



//////////////////
// WEBPACK FOOTER
// ./~/gl-quat/set.js
// module id = 1349
// module chunks = 0